// extracted by mini-css-extract-plugin
export default {"container":"CreatePost_container__AHBdd","header":"CreatePost_header__JfnoJ"};